export default __webpack_public_path__ + "static/media/093-up-arrow-3.b3457cdf.png";